import { basicColors, retroColors, electricColors } from "style/basic/basicColors";
export const formFeildStyle = {
  feildStyle: {
    default: {},
    retro: {
      marginBottom: "15px",
    },
    electric: {
      marginBottom: "15px",
    },
  },
  lblStyle: {
    default: {
      marginBottom: "5px",
      float: "left",
      fontSize: "14px",
      color: basicColors.first,
    },
    retro: {
      marginBottom: "5px",
      fontSize: "14px",
      fontWeight: "bold",
      color: "var(--second)",
      width: "30%",
    },
    electric: {
      marginBottom: "5px",
      fontSize: "14px",
      fontWeight: "bold",
      color: electricColors.second,
      width: "30%",
    },
  },
  lblSmallStyle: {
    default: {
      marginBottom: "5px",
      float: "left",
      fontSize: "14px",
      color: basicColors.first,
    },
    retro: {
      marginBottom: "5px",
      fontSize: "14px",
      fontWeight: "bold",
      color: "var(--second)",
      width: "auto",
    },
    electric: {
      marginBottom: "5px",
      fontSize: "14px",
      fontWeight: "bold",
      color: electricColors.second,
      width: "auto",
    },
  },
  inputStyle: {
    default: {
      width: "100%",
      height: "34px",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: "var(--first)",
      backgroundColor: "var(--fifth)",
      backgroundImage: "none",
      border: "1px solid #e3e9ef",
      borderRadius: "2px",
      WebkitBoxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.05)",
      boxShadow: "inset 0 1px 1px rgba(0, 0, 0, 0.05)",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
    retro: {
      width: "70%",
      height: "34px",
      padding: "6px 6px 6px 6px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: "var(--second)",
      backgroundColor: "var(--fifth)",
      backgroundImage: "none",
      border: "1px solid" + "var(--ten)",
      borderRadius: "0px",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
    electric: {
      width: "70%",
      height: "34px",
      padding: "6px 6px 6px 6px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: electricColors.second,
      backgroundColor: electricColors.fifth,
      backgroundImage: "none",
      border: "1px solid" + electricColors.ten,
      borderRadius: "0px",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
  },
  selectInputFieldContainer: {
    default: {},
    retro: {
      width: "70%",
      position: "relative",
    },
    electric: {
      width: "70%",
      position: "relative",
    },
  },

  selectInputCaret: {
    default: { height: "34px", padding: "6px 12px", background: "var(--fifth)" },
    retro: {
      height: "34px",

      padding: "6px 6px 6px 6px",
      background: "var(--fifth)",
      border: "0px solid grey",
      borderLeft: "none",
      cursor: "pointer",
    },
    electric: {
      height: "34px",

      padding: "6px 6px 6px 6px",
      background: "var(--fifth)",
      border: "0px solid grey",
      borderLeft: "none",
      cursor: "pointer",
    },
  },
  selectInputDropDown: {
    default: {},
    retro: {
      border: "0",
      position: "absolute",
      bottom: "-68px",
      height: "68px",
      overflow: "auto",
      width: "100%",
      zIndex: "10",
      WebkitBoxShadow: " 0px 3px 5px 0px rgba(0,0,0,0.75)",
      MozBoxShadow: "0px 3px 5px 0px rgba(0,0,0,0.75)",
      boxShadow: "0px 3px 5px 0px rgba(0,0,0,0.75)",
      background: "var(--fifth)",
    },
    electric: {
      border: "0",
      position: "absolute",
      bottom: "-68px",
      height: "68px",
      overflow: "auto",
      width: "100%",
      zIndex: "10",
      WebkitBoxShadow: " 0px 3px 5px 0px rgba(0,0,0,0.75)",
      MozBoxShadow: "0px 3px 5px 0px rgba(0,0,0,0.75)",
      boxShadow: "0px 3px 5px 0px rgba(0,0,0,0.75)",
      background: "var(--fifth)",
    },
  },
  inputSelectFieldStyle: {
    default: {},
    retro: {
      height: "34px",
      width: "-webkit-calc(100% - 77px)",
      width: " -moz-calc(100% - 77x)",
      width: "      calc(100% - 77px)",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: "var(--second)",
      backgroundColor: "var(--fifth)",
      backgroundImage: "none",
      border: "0px solid grey",
      borderRadius: "0px",
      borderRight: "none",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
    electric: {
      height: "34px",
      width: "-webkit-calc(100% - 77px)",
      width: " -moz-calc(100% - 77x)",
      width: "      calc(100% - 77px)",
      padding: "6px 12px",
      fontSize: "12px",
      lineHeight: "1.42857143",
      color: electricColors.second,
      backgroundColor: electricColors.fifth,
      backgroundImage: "none",
      border: "0px solid grey",
      borderRadius: "0px",
      borderRight: "none",
      WebkitTransition: "border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
      OTransition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s",
      transition: "border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s",
    },
  },
  inputSelectRowContainer: {
    default: {},
    retro: {
      height: "34px",
      padding: "6px 12px 9px",
      background: "var(--fifth)",
      border: "0px solid darkgrey",
      cursor: "pointer",
    },
    electric: {
      height: "34px",
      padding: "6px 12px 9px",
      background: "var(--fifth)",
      border: "0px solid darkgrey",
      cursor: "pointer",
    },
  },
};



// WEBPACK FOOTER //
// ./src/wigets/forms/style/formFields.js